export const getFirstSentenceOfString = (string) => {
    if (typeof string !== 'string' || !string) return '';

    const sentences = string.split('.');

    return sentences[0];
};
